import React, { useState } from 'react';
import ActionButton from './ActionButton';
import { StyledSelect } from '../../RouteExecution/Pickups/PickupManagement/components/Select';
import { isEqual } from 'lodash/lang';

// Checks for errors for each field
const getFieldError = (field, value) => {
  switch (field) {
    case 'inboundTerminal':
      return value?.trim() ? null : '* Required';
    case 'trailerStatus':
      return value?.trim() ? null : '* Required';
    default:
      return null;
  }
};

const UpdateTrailer = ({
  assetInfo,
  updateEquipment,
  terminalOptions,
  statusOptions,
  classes,
  updateInProgress,
  onClose,
  formErrorMessage,
  clearFormErrorMessage
}) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [trailerInfo, setTrailerInfo] = useState({
    inboundTerminal: assetInfo?.inboundTerminal || null,
    trailerStatus: assetInfo?.trailerStatus || null
  });

  const [errorInfo, setErrorInfo] = useState(null);

  const handleChange = (name) => (value) => {
    value = value?.value || null;
    setTrailerInfo((prevState) => ({
      ...prevState,
      [name]: value
    }));
    setErrorInfo((prevState) => ({
      ...prevState,
      [name]: getFieldError(name, value)
    }));
    if (errorMessage) {
      setErrorMessage(null);
    }
    if (formErrorMessage) {
      clearFormErrorMessage();
    }
  };

  // Set Error messages for each field
  const getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(trailerInfo).forEach((fieldName) => {
      errorInfo[fieldName] = getFieldError(fieldName, trailerInfo[fieldName]);
    });
    setErrorInfo(errorInfo);
    return errorInfo;
  };

  const updateTrailer = () => {
    const errorInfo = getErrorInfo();
    const errorData = Object.values(errorInfo).filter((value) => value).length;
    if (!errorData) {
      const data = {
        ...assetInfo,
        ...trailerInfo
      };
      if (isEqual(data, assetInfo)) {
        setErrorMessage('No changes to update');
        return;
      }
      updateEquipment({
        equipmentId: data.trailerId,
        equipmentNumber: data.trailerNumber,
        equipmentStatus: data.trailerStatus,
        equipmentScac: data.trailerScac,
        equipmentType: data.trailerType,
        inboundTerminal: data.inboundTerminal,
        outboundTerminal: data.outboundTerminal
      });
    }
  };

  return (
    <>
      <div className={classes.formValue}>
        <StyledSelect
          textFieldProps={{
            id: 'TrailerStatus',
            label: 'Trailer Status',
            variant: 'outlined',
            helperText: errorInfo?.trailerStatus
          }}
          value={trailerInfo?.trailerStatus}
          error={errorInfo?.trailerStatus}
          onChange={handleChange('trailerStatus')}
          data={statusOptions}
        />
      </div>

      <div className={classes.formValue}>
        <StyledSelect
          textFieldProps={{
            id: 'CurrentTerminal',
            label: 'Current Terminal',
            variant: 'outlined',
            helperText: errorInfo?.inboundTerminal
          }}
          value={trailerInfo?.inboundTerminal}
          error={errorInfo?.inboundTerminal}
          onChange={handleChange('inboundTerminal')}
          data={terminalOptions}
        />
      </div>
      {errorMessage || formErrorMessage ? (
        <div className={classes.errorMessage}>{errorMessage || formErrorMessage}</div>
      ) : null}
      <ActionButton
        classes={classes}
        onClose={onClose}
        updateInProgress={updateInProgress}
        updateEquipment={updateTrailer}
        errorMessage={errorMessage}
      />
    </>
  );
};

export default UpdateTrailer;
